import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Locale } from 'date-fns';
import dateEn from 'date-fns/locale/en-US';
import datePt from 'date-fns/locale/pt-BR';
import en from './locales/en.json';
import ptBR from './locales/pt-br.json';

export const availableLanguages = [
  { name: 'English', code: 'en-US', date: dateEn },
  { name: 'Português', code: 'pt-BR', date: datePt },
];

export const defaultNS = 'en-US';
export const resources = {
  'en-US': en,
  'pt-BR': ptBR,
} as const;

export const getLocaleDateFile = (): Locale => {
  const currentLanguage = i18n.language;
  const lang = availableLanguages.find(lng => lng.code === currentLanguage);
  if (lang) {
    return lang.date;
  }
  return dateEn;
};

export const storeLanguage = (language: string): void => {
  localStorage.setItem('@minerAI:language', JSON.stringify(language));
};

export const loadStoredLanguage = (): string => {
  const language = localStorage.getItem('@minerAI:language');

  if (language) {
    return language;
  }

  return '';
};

i18n.use(initReactI18next).init({
  lng: navigator.language,
  ns: 'en-US',
  fallbackLng: 'en-US',
  defaultNS,
  resources,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
